import { FelaStyle } from 'react-fela';

export const ipoName: FelaStyle<Theme, {}> = ({ theme }) => ({
  wordBreak: 'break-word',
});

export const ipoLogo: FelaStyle<Theme, {}> = ({ theme }) => ({
  width: '40px',
  height: '40px',
});
